<template>
  <v-card class="left-vertical-card">
    <div class="d-flex flex-column bg-titre mb-2">
      <div class="d-flex justify-space-between">
        <div class="secondary--text align-self-center pl-3 titre-h3 mr-auto">
          Nouveaux contrats à répartir
        </div>
        <v-btn
          class="align-self-center"
          text
          @click="onClose"
        >
          <v-icon color="secondary">
            mdi-close
          </v-icon>
        </v-btn>
      </div>
      <div
        class="primary--text ml-3 intro"
        label
      >
        {{ typeCultureSelected.nom }}
      </div>
    </div>
    <BaseLoader v-if="loading.contrat" />
    <div
      v-for="(contrat, index) in contratsModifiable"
      :key="contrat.id"
      class="card ma-4 pa-4"
    >
      <div class="d-flex">
        <div class="align-self-center mr-2">
          <v-badge
            inline
            color="secondary"
            :content="index + 1"
          />
        </div>
        <div class="d-flex flex-column">
          <div class="intro secondary--text">
            Contrat de {{ contrat?.poidsEnTonne }} t
          </div>
          <div class="texte texte-gris-fonce">
            {{ contrat?.typeContrat?.libelle }}
          </div>
        </div>
      </div>
      <v-divider class="my-3" />
      <div class="mt-2 intro">
        A quelle culture voulez-vous l'affecter?
      </div>
    
      <v-row
        v-for="culture in contrat.cultures"
        :key="culture.id"
        class="mt-6"
        no-gutters
      >
        <v-col
          cols="7"
          class="intro align-self-center primary--text"
        >
          {{ culture.typeCulture.nom }}
        </v-col>
        <v-col class="align-self-center">
          <AgrialInputNumber
            v-model="culture.poidsEnTonne"
            :rules="[rules.required]"
            label="Répartition"
            suffix="t"
            hide-details
          />
        </v-col>
      </v-row>
      <BaseMessage
        v-if="hasErreurCalculRepartition(contrat)"
        class="mb-4 mx-5 mt-2"
        color="error"
        message="Répartition des tonnages invalide"
        text
        type="error"
      />
    </div>
  
    <BaseMessage
      v-if="erreur"
      class="mb-4 mx-5 mt-2"
      color="error"
      :message="erreur"
      text
      type="error"
    />
    
    <div class="d-flex justify-space-around mb-5">
      <AgrButton
        class="pa-5"
        outlined
        @click="onClose()"
      >
        Annuler
      </AgrButton>
      <AgrButton
        :disabled="!isValid"
        :loading="loading"
        class="pa-5"
        @click="saveContrats()"
      >
        Valider
      </AgrButton>
    </div>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import {clone} from '@/utils/clone'
import { sum } from 'lodash'
import { equalDecimals } from'@/utils/math'
import { AgrButton } from '@agrial/ui'
import AgrialInputNumber from '@/components/form/agrial-input-number.vue'
import BaseLoader from '@/components/common/base-loader.vue'
import BaseMessage from '@/components/common/base-message.vue'

export default {
  name: 'ListeContratsARepartirAdherentModal',
  components: {AgrButton, AgrialInputNumber, BaseLoader, BaseMessage},
  props: {
    typeCultureSelected: {
      type: Object,
      default: null
    },
    contrats: {
      type: Array,
      default: null
    }
  },

  data () {
    return {
      loading: false,
      erreur: false,
      contratsModifiable: [],
      rules: {
        required: value => (value !== null && value !== '') || 'Champ requis'
      }
    }
  },
  computed: {
    isValid () {
      return this.contratsModifiable.map(c => c.cultures).filter(c => c.poidsEnTonne === null).length === 0 && this.contratsModifiable.map(contrat => contrat).filter(
        contrat => this.hasErreurCalculRepartition(contrat)).length === 0
    },
    
  },
  watch: {
    typeCultureSelected () {
      this.contratsModifiable = clone(this.contrats)
    }
  },

  created () {
    this.contratsModifiable = clone(this.contrats)
  },
  methods: {
    ...mapActions({
      createOrUpdateContratVente: 'contratVente/createOrUpdateContratVente'
    }),
    hasErreurCalculRepartition (contrat) {
      return !equalDecimals(sum(contrat.cultures.map(c => c.poidsEnTonne)), contrat.poidsEnTonne)
    },
    onClose () {
      this.$emit('close')
    },
    saveContrats () {
      this.loading = true
      this.erreur = null
      this.contratsModifiable.forEach((c => {
        let contrat = {}
        contrat.id = c.id
        contrat.numtiers = c.numtiers
        contrat.anneeRecolte = c.anneeRecolte
        contrat.contratAgrial = c.contratAgrial
        contrat.cultures = c.cultures
        contrat.dateCreation = c.dateCreation
        contrat.userCreation = c.userCreation
        contrat.libelle = c.libelle
        contrat.typeContrat = c.typeContrat
        contrat.poidsEnTonne = c.poidsEnTonne
        contrat.typePrix = c.typePrix
        contrat.prixPayeEnEuroParTonne = c.prixPayeEnEuroParTonne
        contrat.typeSaisie = 'SAISIE_MANUELLE'
        contrat.isPrixProvisoire = c.isPrixProvisoire != null ? c.isPrixProvisoire: false
        this.createOrUpdateContratVente(contrat)
          .catch(err => {
            this.erreur = err.response.data.message
          })
      }))
      this.$emit('close')
      this.$emit('reload')
      this.loading = false
    }
  }
}
</script>
<style lang="scss" scoped>
.left-vertical-card {
  border-radius: 0px !important;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  overflow-y: auto;
}
.bg-titre {
  height: 70px;
  background-color: #f1f2f5;
}
.card {
  border: 1px solid #d7d8d6;
  border-radius: 4px;
}
</style>
